import { render, staticRenderFns } from "./DataTables.vue?vue&type=template&id=f19f5acc&scoped=true"
import script from "./DataTables.vue?vue&type=script&lang=js"
export * from "./DataTables.vue?vue&type=script&lang=js"
import style0 from "./DataTables.vue?vue&type=style&index=0&id=f19f5acc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19f5acc",
  null
  
)

export default component.exports